import { render, staticRenderFns } from "./EventStatsContent.vue?vue&type=template&id=be879a5c"
import script from "./EventStatsContent.vue?vue&type=script&lang=js"
export * from "./EventStatsContent.vue?vue&type=script&lang=js"
import style0 from "./EventStatsContent.vue?vue&type=style&index=0&id=be879a5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports